// The switch to another industry's dashboard. One button that names the
// dashboard in view, opening a modal list of every dashboard. A native
// <dialog> opened with showModal() handles focus trapping, Escape, and the
// top layer at every width, so there is no custom popup to position or clip.
//
// Every entry is a real link to the path form ("/pmb/insight"), so the same
// page opens in the other industry. router.ts turns an ordinary click on it
// into a client-side navigation; a middle click still opens a new tab.
import { useId, useRef } from "react";
import { ConsoleGlyph } from "@dashboard-intelligent/ui";
import { useIndustry } from "./industry";
import { industryPath } from "./tenant";

export function IndustrySwitcher() {
  const { slug, summary, all } = useIndustry();
  const dialog = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  const current = summary?.shortName ?? slug;
  const pathname = typeof location === "undefined" ? "/" : location.pathname;

  return (
    <>
      <button
        type="button"
        className="dash-switch"
        aria-haspopup="dialog"
        aria-label={`Dashboard ${current}, ganti dashboard`}
        onClick={() => dialog.current?.showModal()}
      >
        <span className="dash-switch-text">
          <span className="dash-switch-label">Dashboard</span>
          <span className="dash-switch-name">{current}</span>
        </span>
        <ConsoleGlyph name="switch" size={20} />
      </button>
      <dialog
        ref={dialog}
        className="dash-dialog"
        aria-labelledby={titleId}
        onClick={(event) => {
          // A click on the backdrop lands on the dialog element itself.
          if (event.target === event.currentTarget) event.currentTarget.close();
        }}
      >
        <div className="dash-dialog-body">
          <div className="dash-dialog-head">
            <h2 className="dash-dialog-title" id={titleId}>
              Pilih dashboard
            </h2>
            <button type="button" className="dash-dialog-close" aria-label="Tutup" onClick={() => dialog.current?.close()}>
              <ConsoleGlyph name="close" size={24} />
            </button>
          </div>
          {all.length === 0 ? (
            <p className="dash-dialog-empty">Daftar dashboard belum termuat.</p>
          ) : (
            <ul className="dash-dialog-list">
              {all.map((industry) => {
                const active = industry.slug === slug;
                return (
                  <li key={industry.slug}>
                    <a
                      className="dash-dialog-item"
                      href={industryPath(industry.slug, pathname)}
                      aria-current={active ? "page" : undefined}
                      onClick={() => dialog.current?.close()}
                    >
                      <span className="dash-dialog-name">{industry.shortName}</span>
                      <span className="dash-dialog-full">{industry.name}</span>
                      {active ? (
                        <span className="dash-dialog-check">
                          <ConsoleGlyph name="check" size={20} label="Sedang dibuka" />
                        </span>
                      ) : null}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </dialog>
    </>
  );
}
